import { AssociateSection } from './components/associate';
import { BenefitsSection } from './components/benefits';
import { ContactSection } from './components/contact';
import { FeedbackSection } from './components/feedback';
import { HubHeader } from './components/header';
import { HubHero } from './components/hero';
import { PlansSection } from './components/plans';
import { ServicesSection } from './components/services';

export const Hub = () => {
  return (
    <>
      <HubHeader />
      <HubHero />
      <BenefitsSection />
      <PlansSection />
      <ServicesSection />
      <FeedbackSection />
      <AssociateSection />
      <ContactSection />
    </>
  );
};
